import React from "react";
import { Link } from "react-router-dom";
import ProfilePopover from "./ProfilePopover";
import logo from "../assets/new-logo.png";
import homeBtn from "../assets/button-home-filled-outline.png";
import discoverIcon from "../assets/star-field-icon.png";
import "./Header.css";

const Header = ({ showHomeBtn, showDiscoverBtn = true }) => {
  return (
    <header className="header">
      <div className="header__left">
        <ProfilePopover />
      </div>
      <div className="header__logo">
        <Link to="/discover">
          <img src={logo} alt="Logo" className="header__logo-img" />
        </Link>
      </div>
      <div className="header__actions">
        {showDiscoverBtn && (
          <Link
            to="/discover"
            className="header__discover-btn"
            title="Discover"
          >
            <img src={discoverIcon} alt="" className="header__discover-icon" />
            <span className="header__discover-text">Discover</span>
          </Link>
        )}
        {showHomeBtn && (
          <Link to="/home" className="header__home-btn">
            <img src={homeBtn} alt="Home" width="100%" />
          </Link>
        )}
      </div>
    </header>
  );
};

export default Header;
